import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-info",
  "use": "icon-info-usage",
  "viewBox": "0 0 39.03 39.03",
  "content": "<symbol viewBox=\"0 0 39.03 39.03\" id=\"icon-info\">\r\n    <path d=\"M25.79,32.3a.79.79,0,0,1-.58.23H13.82a.78.78,0,0,1-.81-.81V27.65a.78.78,0,0,1,.81-.81h2.44V18.7H13.82a.78.78,0,0,1-.81-.81V13.82a.78.78,0,0,1,.81-.81H22a.78.78,0,0,1,.81.81v13h2.44a.78.78,0,0,1,.81.81v4.07A.79.79,0,0,1,25.79,32.3ZM22.54,9.53a.79.79,0,0,1-.58.23H17.08a.78.78,0,0,1-.81-.81V4.88a.78.78,0,0,1,.81-.81H22a.78.78,0,0,1,.81.81V8.94A.79.79,0,0,1,22.54,9.53Zm13.87.19a19.43,19.43,0,0,0-7.1-7.1A19.09,19.09,0,0,0,19.51,0a19.09,19.09,0,0,0-9.8,2.62,19.43,19.43,0,0,0-7.1,7.1A19.09,19.09,0,0,0,0,19.51a19.09,19.09,0,0,0,2.62,9.8,19.43,19.43,0,0,0,7.1,7.1A19.09,19.09,0,0,0,19.51,39a19.09,19.09,0,0,0,9.8-2.62,19.43,19.43,0,0,0,7.1-7.1A19.09,19.09,0,0,0,39,19.51,19.09,19.09,0,0,0,36.41,9.72Z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./app/general/svg/info.svg
// module id = ./app/general/svg/info.svg
// module chunks = app